import classnames from "owa-classnames";
import { sclMultiLinePreviewStyles, mclMultiLinePreviewStyles, twoLinePreviewStyles, oneLinePreviewStyles, noPreviewStyles, } from "owa-mail-listitem-styles/lib/scss/previewTextStyles.scss";

function getPreviewTextStyles(isMCL: boolean, numMessagePreviewLines: number): string | undefined {
    let previewClass = "";
    if (numMessagePreviewLines === 2) {
        previewClass = twoLinePreviewStyles;
    }
    else if (numMessagePreviewLines === 1) {
        previewClass = oneLinePreviewStyles;
    }
    else {
        previewClass = noPreviewStyles;
    }
    return classnames(previewClass, isMCL ? mclMultiLinePreviewStyles : sclMultiLinePreviewStyles);
}
export default getPreviewTextStyles;
